import { render, staticRenderFns } from "./tiyaJob.vue?vue&type=template&id=4d0934ff&"
import script from "./tiyaJob.vue?vue&type=script&lang=js&"
export * from "./tiyaJob.vue?vue&type=script&lang=js&"
import style0 from "./tiyaJob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports